import { store } from "store";

const NIMBBLE_ALERT_ENDPOINT = "https://api.nimbble.team/api/integrations/alert-push/events";


// nimbble's errorType is a fixed enum: server | client | browser_crash | uptime.
// A render crash blanks the whole UI (a "browser_crash"); uncaught errors and
// unhandled rejections may leave the page usable, so they're plain "client" errors.
const NIMBBLE_ERROR_TYPE_BY_SOURCE = {
  render: "browser_crash",
  uncaught: "client",
  unhandledRejection: "client",
};

const SEVERITY_BY_SOURCE = {
  render: "high",
  uncaught: "medium",
  unhandledRejection: "medium",
};

// Matches the backend's existing fingerprint convention (dash-joined, dynamic
// path segments normalized to the literal "id") so tickets from both services
// dedupe/read consistently in the nimbble dashboard.
const normalizePath = (pathname) =>
  pathname
    .split("/")
    .map((segment) => (/^[0-9a-f]{8,}$|^\d+$/i.test(segment) ? "id" : segment))
    .join("/");

const slugify = (value) =>
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const reportClientCrashToNimbble = ({
                                             errorType: source,
                                             error,
                                             componentStack,
                                           }) => {
  try {
    const isEnabled =
      process.env.NODE_ENV === "production" && process.env.REACT_APP_ENABLE_NIMBBLE_ALERTS === "true";
    const token = process.env.REACT_APP_NIMBBLE_ALERT_TOKEN;

    if (!isEnabled || !token) return;

    const { pathname, href } = window.location;
    const staffId = store.getState()?.user?.current?.details?.userId;

    const payload = {
      externalId: slugify(`web-${source}-${pathname}`),
      fingerprint: slugify(`web-${source}-production-${normalizePath(pathname)}`),
      title: `Client side error: ${pathname}`,
      description: `${source} crash on ${pathname}: ${error.message}`,
      severity: SEVERITY_BY_SOURCE[source],
      environment: "production",
      service: "web",
      errorType: NIMBBLE_ERROR_TYPE_BY_SOURCE[source],
      url: href,
      occurredAt: new Date().toISOString(),
      metadata: {
        source,
        userAgent: navigator.userAgent,
        ...(componentStack ? { componentStack } : {}),
        ...(staffId ? { staffId } : {}),
      },
    };

    fetch(NIMBBLE_ALERT_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    }).catch(() => { });
  } catch {
    // crash reporting must never break the crash-handling path itself
  }
};
